import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  FormControl,
  Box,
  Select,
  Typography,
  Button,
  MenuItem,
  TablePagination,
  Avatar,
  TextField,
  Grid,
  FormHelperText,
  InputLabel,
} from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import RestoreIcon from "@mui/icons-material/Restore";
import { styled } from "@mui/system";

import Colors from "../../../../assets/styles";
import { Svgs } from "../../../../assets/images";
import { useNavigate } from "react-router-dom";
import PropertyServices from "../../../../api/PropertyServices/property.index";
import AuthServices from "../../../../api/AuthServices/auth.index";
import { ErrorHandler } from "../../../../utils/ErrorHandler";
import SimpleDialog from "../../../../components/Dialog/index";
import Loader from "../../../../components/Loader";

const tableHead = [
  "SR No",
  "Property Name",
  "Sold type",
  "Agent Name",
  "Sold date"
];

const CustomSelect = styled(Select)({
  "&.MuiSelect-root": {
    border: "none",
    outline: "none",
    boxShadow: "none",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "& .MuiSelect-icon": {
    color: "black",
  },
  "& .MuiSelect-select": {
    padding: "8px 32px 8px 8px",
  },
});

const ClosedDeals = () => {
  const [data, setData] = useState([]);
  const [id, setId] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const navigate = useNavigate();
  const [selectedPropertyId, setSelectedPropertyId] = useState("");
  const [property, setProperty] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  const [openSoldDialog, setOpenSoldDialog] = useState(false);
  const [openDealClosedDialog, setOpenDealClosedDialog] = useState(false);
  const [agents, setAgents] = useState([]);
  const [soldBy, setSoldBy] = useState("");
  const [soldError, setSoldError] = useState("");

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const sleep = () => new Promise((r) => setTimeout(r, 1000));

  const getClosedDeals = async (
    searchParam = "",
    idParam = "",
    pageParam = 1,
    limitParam = 10,

  ) => {
    setLoading(true);
    try {
      await sleep();
      const { data } = await PropertyServices.getClosedDeals(
        searchParam,
        idParam,
        pageParam,
        limitParam
      );
      setData(data?.properties);
      setCount(data.count);
    } catch (error) {
      ErrorHandler(error);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getClosedDeals(search, id, page + 1, limit);
  }, [page, limit, search]);

  const handleSearch = () => {
    getClosedDeals(search, id, 1, limit);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleReset = () => {
    setId("");
    setSearch("");
    getClosedDeals("", "", 1, limit);
  };

  const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );
  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "AED",
      minimumFractionDigits: 0,
    }).format(price);
  };

  return (
    <Box sx={{ padding: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 8,
        }}
      >
        <Typography
          sx={{ fontSize: "26px", color: Colors.primary, fontWeight: "600" }}
        >
          Closed Deals
        </Typography>
      </Box>
      <Grid
        container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "20px",
        }}
      >
        <Grid
          item
          display="flex"
          alignItems="center"
          sx={{ mt: 3, pl: 2 }}
          bgcolor={Colors.backgroundColor}
          border="1px solid rgba(10, 10, 10, 0.1)"
          borderRadius={2}
          boxShadow="0xp 0px 100px 0xp rgba(0,0,0,0.1)"
        >
          {/* <FilterAltIcon /> */}
          {/* <Box
            sx={{
              width: "1px",
              height: "40px",
              backgroundColor: "lightgray",
              mx: 1,
            }}
          /> */}
          {/* <Box sx={{ px: 2, width: "100px" }}>Filter By</Box> */}

          {/* <Box
            sx={{
              width: "1px",
              height: "40px",
              backgroundColor: "lightgray",
              mx: 1,
            }}
          /> */}
          <TextField
            placeholder="Search"
            InputProps={{
              sx: {
                input: {
                  paddingTop: "7px !important",
                  paddingBottom: "7px !important",
                  paddingRight: "50px !important",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              },
            }}
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <Box
            sx={{
              width: "1px",
              height: "40px",
              backgroundColor: "lightgray",
              mx: 1,
            }}
          />
          <Button
            sx={{ color: Colors.red, mx: 1 }}
            startIcon={<RestoreIcon />}
            onClick={handleReset}
          >
            Reset Filter
          </Button>
        </Grid>
      </Grid>
      <TableContainer
        sx={{
          mt: 2,
          backgroundColor: Colors.backgroundColor,
          borderRadius: "10px",
        }}
        component={Paper}
      >
        <Table>
          <TableHead>
            <TableRow>
              {tableHead.map((column, index) => (
                <TableCell
                  key={index}
                  sx={{
                    fontWeight: "600",
                    color: Colors.black,
                    textAlign:
                      column === "Management Company" ? "left" : "center",
                  }}
                >
                  {column}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {loading ? (
            <TableRow>
              <TableCell colSpan={tableHead.length}>
                <Loader width="40px" height="40px" color={Colors.primary} />
              </TableCell>
            </TableRow>
          ) : (
            filteredData.map((row, index) => (
              <TableBody key={row._id}>
                <TableRow>
                  <TableCell sx={{ textAlign: "center" }}>
                    {index + 1}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", textDecoration: "underline" }}
                    onClick={() =>
                      navigate(`/properties/details/${row?._id}`)
                    }
                  >
                    {row?.name}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", textTransform: "capitalize" }}>
                    {row?.soldType === "agent" ? "Agent Sold" : "Internal Sold"}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", textDecoration: row?.soldType === "agent" && row?.agent ? "underline" : "default" }}
                    onClick={() => row?.soldType === "agent" && row?.agent ? navigate(`/agent/detail/${row.agent._id}`) : null}
                  >
                    {row?.soldType === "agent" && row?.agent ? row.agent.name : "-"}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {row?.soldAt ? new Date(row.soldAt).toLocaleDateString() : "-"}
                  </TableCell>
                </TableRow>
              </TableBody>
            ))
          )}
        </Table>
      </TableContainer>

      <SimpleDialog
        open={openDealClosedDialog}
        onClose={() => setOpenDealClosedDialog(false)}
        border={`4px solid ${Colors.primary}`}
        title="Closed Deal Details"
      >
        <Box sx={{ mt: 1 }}>
          {/* SOLD TYPE */}
          <Typography sx={{ fontWeight: 600, mb: 1 }}>
            Sold Type:
            <span style={{ marginLeft: 6, textTransform: "capitalize" }}>
              {property?.soldType === "agent" ? "Agent Sold" : "Internal Sold"}
            </span>
          </Typography>

          {/* AGENT SOLD */}
          {property?.soldType === "agent" && property?.soldAgent && (
            <Box sx={{ mt: 2 }}>
              <Typography sx={{ fontWeight: 600, mb: 1 }}>
                Agent Details:
              </Typography>

              <Typography>
                <b>Name:</b> {property.soldAgent.name}
              </Typography>

              <Typography>
                <b>Email:</b> {property.soldAgent.email}
              </Typography>

              <Typography>
                <b>Phone:</b> {property.soldAgent.phone}
              </Typography>
            </Box>
          )}

          {/* INTERNAL SOLD */}
          {property?.soldType !== "agent" && (
            <Box sx={{ mt: 2 }}>
              <Typography sx={{ fontWeight: 600 }}>
                This property was sold internally (Self Sold).
              </Typography>
            </Box>
          )}

          {/* SOLD DATE */}
          {property?.soldAt && (
            <Box sx={{ mt: 2 }}>
              <Typography>
                <b>Sold On:</b>{" "}
                {new Date(property.soldAt).toLocaleDateString()}
              </Typography>
            </Box>
          )}
        </Box>
      </SimpleDialog>

      <Box
        sx={{
          mt: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{ color: "text.secondary", ml: 2 }}>
          {`Showing ${page * limit + 1}-${Math.min(
            (page + 1) * limit,
            count
          )} of ${count}`}
        </Typography>
        <Box>
          <TablePagination
            component={Paper}
            sx={{
              borderBottom: "none",
              border: "1px solid black",
              bgcolor: "transparent",
              ".MuiTablePagination-toolbar": {
                paddingLeft: 0,
              },
              ".MuiTablePagination-spacer": {
                flex: "none",
              },
              ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows":
              {
                display: "none",
              },
              ".MuiTablePagination-actions": {
                marginLeft: 0,
              },
              ".MuiTablePagination-actions button:first-child": {
                borderRadius: 0,
                p: 0,
                pr: "8px",
                borderRight: "1px solid black",
              },
              ".css-78c6dr-MuiToolbar-root-MuiTablePagination-toolbar .MuiTablePagination-actions":
              {
                marginLeft: "14px !important",
              },
              ".MuiTablePagination-toolbar": {
                minHeight: "14px !important",
                padding: "0px !important",
              },
            }}
            rowsPerPageOptions={[]} // Removes rows per page selector
            count={count}
            rowsPerPage={limit}
            page={page}
            onPageChange={handlePageChange}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ClosedDeals;
